namespace RedBullMOBILE360.PushNotifications {
    export class PushNotificationsPGColumns {
        static columnsKey = 'PushNotifications.PushNotificationsPG';
    }
}